import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, unref as _unref, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-gray-50 py-8" };
const _hoisted_2 = { class: "max-w-2xl mx-auto px-4" };
const _hoisted_3 = {
    key: 0,
    class: "bg-white rounded-lg shadow-md p-8 text-center"
};
const _hoisted_4 = { class: "bg-white rounded-lg shadow-md p-8 text-center" };
const _hoisted_5 = { class: "text-gray-600 mb-6" };
const _hoisted_6 = { class: "space-y-3" };
const _hoisted_7 = { class: "bg-white rounded-lg shadow-md p-8" };
const _hoisted_8 = { class: "text-center mb-8" };
const _hoisted_9 = ["src"];
const _hoisted_10 = {
    key: 0,
    class: "space-y-6"
};
const _hoisted_11 = { class: "bg-red-50 border border-red-200 rounded-lg p-6 text-center" };
const _hoisted_12 = {
    class: "text-3xl font-bold text-red-600 mb-2",
    style: { "color": "#dc2626 !important" }
};
const _hoisted_13 = { class: "bg-gray-50 rounded-lg p-4 border border-gray-200" };
const _hoisted_14 = { class: "max-h-64 overflow-y-auto space-y-3 pr-2" };
const _hoisted_15 = { class: "flex-1" };
const _hoisted_16 = {
    class: "font-medium text-gray-900",
    style: { "color": "#111827 !important" }
};
const _hoisted_17 = {
    class: "text-sm text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_18 = {
    key: 0,
    class: "text-xs text-green-700 mt-1 bg-green-50 p-1 rounded",
    style: { "color": "#15803d !important" }
};
const _hoisted_19 = {
    key: 1,
    class: "text-xs text-red-700 mt-1 bg-red-50 p-1 rounded",
    style: { "color": "#be123c !important" }
};
const _hoisted_20 = {
    key: 2,
    class: "text-xs text-gray-600 mt-1 bg-yellow-50 p-1 rounded italic",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_21 = { class: "text-right ml-4" };
const _hoisted_22 = {
    class: "font-semibold text-gray-900",
    style: { "color": "#111827 !important" }
};
const _hoisted_23 = { class: "border-t border-gray-300 mt-4 pt-4" };
const _hoisted_24 = {
    key: 0,
    class: "flex justify-between text-sm mb-2"
};
const _hoisted_25 = {
    class: "text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_26 = {
    key: 1,
    class: "flex justify-between text-sm mb-2"
};
const _hoisted_27 = {
    class: "text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_28 = {
    key: 2,
    class: "flex justify-between text-sm mb-2"
};
const _hoisted_29 = {
    class: "text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_30 = { class: "flex justify-between text-lg font-bold" };
const _hoisted_31 = {
    class: "text-red-600",
    style: { "color": "#dc2626 !important" }
};
const _hoisted_32 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" };
const _hoisted_33 = { class: "bg-gray-50 rounded-lg p-4 space-y-2" };
const _hoisted_34 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_35 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_36 = { key: 0 };
const _hoisted_37 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_38 = {
    class: "text-lg font-semibold text-gray-900 mb-4",
    style: { "color": "#111827 !important" }
};
const _hoisted_39 = { class: "bg-gray-50 rounded-lg p-4 space-y-2" };
const _hoisted_40 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_41 = { key: 0 };
const _hoisted_42 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_43 = { key: 1 };
const _hoisted_44 = { class: "bg-gray-50 rounded-lg p-4" };
const _hoisted_45 = { class: "flex items-center justify-between" };
const _hoisted_46 = { class: "flex items-center" };
const _hoisted_47 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_48 = {
    class: "text-sm text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_49 = { class: "text-right" };
const _hoisted_50 = {
    class: "font-bold text-lg",
    style: { "color": "#111827 !important" }
};
const _hoisted_51 = {
    key: 0,
    class: "text-sm text-green-600",
    style: { "color": "#059669 !important" }
};
const _hoisted_52 = { key: 0 };
const _hoisted_53 = { class: "bg-yellow-50 border border-yellow-200 rounded-lg p-4" };
const _hoisted_54 = { class: "text-gray-700" };
const _hoisted_55 = { class: "bg-blue-50 border border-blue-200 rounded-lg p-6" };
const _hoisted_56 = { class: "space-y-2 text-blue-800" };
const _hoisted_57 = { class: "flex items-start" };
const _hoisted_58 = { class: "font-medium" };
const _hoisted_59 = { class: "text-sm" };
const _hoisted_60 = { class: "mt-8 space-y-3" };
import { ref, onMounted, inject } from 'vue';
import { useRoute } from 'vue-router';
import defaultFoodImage from '@/assets/default-food-image.svg';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSuccessPage',
    setup(__props) {
        const route = useRoute();
        const apiClient = inject('apiClient');
        // State
        const loading = ref(true);
        const error = ref(null);
        const order = ref(null);
        const successLogo = defaultFoodImage;
        // Get order number from URL params (route parameter, not query parameter)
        const orderNumber = route.params.orderNumber;
        console.log('🔍 DEBUG: Order Success Page loaded');
        console.log('🔍 DEBUG: route.params:', route.params);
        console.log('🔍 DEBUG: route.query:', route.query);
        console.log('🔍 DEBUG: orderNumber from params:', orderNumber);
        // Load order details
        const loadOrderDetails = async () => {
            if (!orderNumber) {
                error.value = 'Keine Bestellnummer gefunden';
                loading.value = false;
                return;
            }
            try {
                loading.value = true;
                error.value = null;
                // ✅ DIRECT API CALL: Use RestaurantApiClient directly
                const response = await apiClient.getOrderByNumber(orderNumber);
                console.log('🔍 DEBUG: Raw API response:', JSON.stringify(response, null, 2));
                if (response.data && response.data.order) {
                    order.value = response.data.order;
                    console.log('🔍 DEBUG: Order set successfully from direct API');
                    console.log('🔍 DEBUG: Order totalAmountCent:', response.data.order.totalAmountCent);
                    console.log('🔍 DEBUG: First item totalPriceCent:', response.data.order.items?.[0]?.totalPriceCent);
                }
                else {
                    error.value = 'Bestellung nicht gefunden';
                }
            }
            catch (err) {
                console.error('Error loading order:', err);
                error.value = err.message || 'Fehler beim Laden der Bestelldetails';
            }
            finally {
                loading.value = false;
            }
        };
        // Helper functions
        const formatPrice = (priceCent) => {
            // Handle undefined/null values
            if (priceCent === undefined || priceCent === null || isNaN(priceCent)) {
                console.warn('formatPrice called with invalid value:', priceCent);
                return '0,00 €';
            }
            // Convert cent to euro
            const priceEuro = priceCent / 100;
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(priceEuro);
        };
        const formatExtraIngredient = (extra) => {
            return `${extra.name} (+${formatPrice(extra.priceCent || 0)})`;
        };
        const getPaymentStatusText = (status) => {
            const statusMap = {
                'pending': 'Ausstehend',
                'paid': 'Bezahlt',
                'failed': 'Fehlgeschlagen',
                'refunded': 'Erstattet'
            };
            return statusMap[status] || status;
        };
        const getPaymentMethodText = (method) => {
            const methodMap = {
                'cash': 'Barzahlung',
                'card': 'Kartenzahlung',
                'paypal': 'PayPal',
                'bank_transfer': 'Überweisung'
            };
            return methodMap[method] || method;
        };
        // Load order on mount
        onMounted(() => {
            loadOrderDetails();
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Loading State "),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4" }, null, -1 /* CACHED */),
                                _createElementVNode("p", { class: "text-gray-600" }, "Lade Bestelldetails...", -1 /* CACHED */)
                            ]))]))
                        : (error.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Error State "),
                                _createElementVNode("div", _hoisted_4, [
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" }, [
                                        _createElementVNode("i", { class: "fas fa-exclamation-triangle text-red-600 text-2xl" })
                                    ], -1 /* CACHED */)),
                                    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 mb-2" }, "Fehler beim Laden der Bestellung", -1 /* CACHED */)),
                                    _createElementVNode("p", _hoisted_5, _toDisplayString(error.value), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("button", {
                                            onClick: loadOrderDetails,
                                            class: "w-full bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors duration-200"
                                        }, " Erneut versuchen "),
                                        _createVNode(_component_router_link, {
                                            to: "/speisekarte",
                                            class: "block w-full bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold transition-colors duration-200 text-center"
                                        }, {
                                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                    _createTextVNode(" Zur Speisekarte ", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        })
                                    ])
                                ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createCommentVNode(" Success State "),
                                _createElementVNode("div", _hoisted_7, [
                                    _createCommentVNode(" Success Header with Logo "),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("img", {
                                            src: _unref(successLogo),
                                            alt: "Eckpunkt Restaurant Logo",
                                            class: "w-20 h-20 mx-auto mb-4 rounded-full object-cover"
                                        }, null, 8 /* PROPS */, _hoisted_9),
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" }, [
                                            _createElementVNode("i", { class: "fas fa-check text-green-600 text-3xl" })
                                        ], -1 /* CACHED */)),
                                        _cache[5] || (_cache[5] = _createElementVNode("h1", {
                                            class: "text-3xl font-bold text-gray-900 mb-2",
                                            style: { "color": "#111827 !important" }
                                        }, "Bestellung erfolgreich!", -1 /* CACHED */)),
                                        _cache[6] || (_cache[6] = _createElementVNode("p", {
                                            class: "text-gray-600",
                                            style: { "color": "#4b5563 !important" }
                                        }, "Vielen Dank für Ihre Bestellung bei Eckpunkt Restaurant", -1 /* CACHED */))
                                    ]),
                                    _createCommentVNode(" Order Details "),
                                    (order.value && order.value.items && order.value.items.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createCommentVNode(" Order Number "),
                                            _createElementVNode("div", _hoisted_11, [
                                                _cache[7] || (_cache[7] = _createElementVNode("h2", {
                                                    class: "text-lg font-semibold text-gray-900 mb-2",
                                                    style: { "color": "#111827 !important" }
                                                }, "Ihre Bestellnummer", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_12, _toDisplayString(order.value.orderNumber), 1 /* TEXT */),
                                                _cache[8] || (_cache[8] = _createElementVNode("p", {
                                                    class: "text-sm text-gray-600",
                                                    style: { "color": "#4b5563 !important" }
                                                }, "Bitte bewahren Sie diese Nummer für Ihre Unterlagen auf", -1 /* CACHED */))
                                            ]),
                                            _createCommentVNode(" Order Summary "),
                                            _createElementVNode("div", null, [
                                                _cache[13] || (_cache[13] = _createElementVNode("h3", {
                                                    class: "text-lg font-semibold text-gray-900 mb-4",
                                                    style: { "color": "#111827 !important" }
                                                }, "Bestellübersicht", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_13, [
                                                    _createElementVNode("div", _hoisted_14, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.items, (item) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: item.productId || item.id || Math.random(),
                                                                class: "flex justify-between items-start p-3 bg-white rounded-lg border border-gray-200"
                                                            }, [
                                                                _createElementVNode("div", _hoisted_15, [
                                                                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.productName), 1 /* TEXT */),
                                                                    _createElementVNode("div", _hoisted_17, "Menge: " + _toDisplayString(item.quantity) + " × " + _toDisplayString(formatPrice(item.unitPriceCent || 0)), 1 /* TEXT */),
                                                                    (item.extraIngredients?.length)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " + " + _toDisplayString(item.extraIngredients.map(formatExtraIngredient).join(', ')), 1 /* TEXT */))
                                                                        : _createCommentVNode("v-if", true),
                                                                    (item.removedIngredients?.length)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " - " + _toDisplayString(item.removedIngredients.join(', ')), 1 /* TEXT */))
                                                                        : _createCommentVNode("v-if", true),
                                                                    (item.specialInstructions)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, " \"" + _toDisplayString(item.specialInstructions) + "\" ", 1 /* TEXT */))
                                                                        : _createCommentVNode("v-if", true)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_21, [
                                                                    _createElementVNode("div", _hoisted_22, _toDisplayString(formatPrice(item.totalPriceCent || 0)), 1 /* TEXT */)
                                                                ])
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_23, [
                                                        (order.value.deliveryFeeCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                _cache[9] || (_cache[9] = _createElementVNode("span", {
                                                                    class: "text-gray-600",
                                                                    style: { "color": "#4b5563 !important" }
                                                                }, "Zwischensumme:", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_25, _toDisplayString(formatPrice(order.value.itemsTotalCent || 0)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        (order.value.deliveryFeeCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                                _cache[10] || (_cache[10] = _createElementVNode("span", {
                                                                    class: "text-gray-600",
                                                                    style: { "color": "#4b5563 !important" }
                                                                }, "Liefergebühr:", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_27, _toDisplayString(formatPrice(order.value.deliveryFeeCent || 0)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        (order.value.serviceFeeCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                                _cache[11] || (_cache[11] = _createElementVNode("span", {
                                                                    class: "text-gray-600",
                                                                    style: { "color": "#4b5563 !important" }
                                                                }, "Servicegebühr:", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_29, _toDisplayString(formatPrice(order.value.serviceFeeCent || 0)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createElementVNode("div", _hoisted_30, [
                                                            _cache[12] || (_cache[12] = _createElementVNode("span", {
                                                                class: "text-gray-900",
                                                                style: { "color": "#111827 !important" }
                                                            }, "Gesamt:", -1 /* CACHED */)),
                                                            _createElementVNode("span", _hoisted_31, _toDisplayString(formatPrice(order.value.totalAmountCent || 0)), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createCommentVNode(" Customer & Delivery Info "),
                                            _createElementVNode("div", _hoisted_32, [
                                                _createCommentVNode(" Customer Info "),
                                                _createElementVNode("div", null, [
                                                    _cache[17] || (_cache[17] = _createElementVNode("h3", {
                                                        class: "text-lg font-semibold text-gray-900 mb-4",
                                                        style: { "color": "#111827 !important" }
                                                    }, "Kundendaten", -1 /* CACHED */)),
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _createElementVNode("div", null, [
                                                            _cache[14] || (_cache[14] = _createElementVNode("span", {
                                                                class: "text-sm text-gray-600",
                                                                style: { "color": "#4b5563 !important" }
                                                            }, "Name:", -1 /* CACHED */)),
                                                            _createElementVNode("div", _hoisted_34, _toDisplayString(order.value.customer.name), 1 /* TEXT */)
                                                        ]),
                                                        _createElementVNode("div", null, [
                                                            _cache[15] || (_cache[15] = _createElementVNode("span", {
                                                                class: "text-sm text-gray-600",
                                                                style: { "color": "#4b5563 !important" }
                                                            }, "E-Mail:", -1 /* CACHED */)),
                                                            _createElementVNode("div", _hoisted_35, _toDisplayString(order.value.customer.email), 1 /* TEXT */)
                                                        ]),
                                                        (order.value.customer.phone)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                                _cache[16] || (_cache[16] = _createElementVNode("span", {
                                                                    class: "text-sm text-gray-600",
                                                                    style: { "color": "#4b5563 !important" }
                                                                }, "Telefon:", -1 /* CACHED */)),
                                                                _createElementVNode("div", _hoisted_37, _toDisplayString(order.value.customer.phone), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]),
                                                _createCommentVNode(" Delivery Info "),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("h3", _hoisted_38, _toDisplayString(order.value.orderType === 'delivery' ? 'Lieferung' : 'Abholung'), 1 /* TEXT */),
                                                    _createElementVNode("div", _hoisted_39, [
                                                        _createElementVNode("div", null, [
                                                            _cache[18] || (_cache[18] = _createElementVNode("span", {
                                                                class: "text-sm text-gray-600",
                                                                style: { "color": "#4b5563 !important" }
                                                            }, "Art:", -1 /* CACHED */)),
                                                            _createElementVNode("div", _hoisted_40, [
                                                                _createElementVNode("i", {
                                                                    class: _normalizeClass([order.value.orderType === 'delivery' ? 'fas fa-motorcycle' : 'fas fa-walking', "mr-2"])
                                                                }, null, 2 /* CLASS */),
                                                                _createTextVNode(" " + _toDisplayString(order.value.orderType === 'delivery' ? 'Lieferung' : 'Abholung'), 1 /* TEXT */)
                                                            ])
                                                        ]),
                                                        (order.value.orderType === 'delivery' && order.value.customer.address && order.value.customer.address.street)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                                _cache[20] || (_cache[20] = _createElementVNode("span", {
                                                                    class: "text-sm text-gray-600",
                                                                    style: { "color": "#4b5563 !important" }
                                                                }, "Adresse:", -1 /* CACHED */)),
                                                                _createElementVNode("div", _hoisted_42, [
                                                                    _createTextVNode(_toDisplayString(order.value.customer.address.street), 1 /* TEXT */),
                                                                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                                                    _createTextVNode(" " + _toDisplayString(order.value.customer.address.postalCode) + " " + _toDisplayString(order.value.customer.address.city), 1 /* TEXT */)
                                                                ])
                                                            ]))
                                                            : (order.value.orderType === 'pickup')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[21] || (_cache[21] = [
                                                                        _createElementVNode("span", {
                                                                            class: "text-sm text-gray-600",
                                                                            style: { "color": "#4b5563 !important" }
                                                                        }, "Restaurant:", -1 /* CACHED */),
                                                                        _createElementVNode("div", {
                                                                            class: "font-medium",
                                                                            style: { "color": "#111827 !important" }
                                                                        }, [
                                                                            _createTextVNode(" Eckpunkt Restaurant"),
                                                                            _createElementVNode("br"),
                                                                            _createTextVNode(" Wolterdinger Straße 15"),
                                                                            _createElementVNode("br"),
                                                                            _createTextVNode(" 78166 Donaueschingen ")
                                                                        ], -1 /* CACHED */)
                                                                    ]))]))
                                                                : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ]),
                                            _createCommentVNode(" Payment Info "),
                                            _createElementVNode("div", null, [
                                                _cache[23] || (_cache[23] = _createElementVNode("h3", {
                                                    class: "text-lg font-semibold text-gray-900 mb-4",
                                                    style: { "color": "#111827 !important" }
                                                }, "Zahlung", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_44, [
                                                    _createElementVNode("div", _hoisted_45, [
                                                        _createElementVNode("div", _hoisted_46, [
                                                            _createElementVNode("i", {
                                                                class: _normalizeClass([order.value.payment.method === 'card' ? 'fas fa-credit-card text-blue-600' : 'fas fa-money-bill-wave text-green-600', "mr-3"])
                                                            }, null, 2 /* CLASS */),
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("div", _hoisted_47, _toDisplayString(getPaymentMethodText(order.value.payment.method)), 1 /* TEXT */),
                                                                _createElementVNode("div", _hoisted_48, " Status: " + _toDisplayString(getPaymentStatusText(order.value.payment.status)), 1 /* TEXT */)
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_49, [
                                                            _createElementVNode("div", _hoisted_50, _toDisplayString(formatPrice(order.value.totalAmountCent || 0)), 1 /* TEXT */),
                                                            (order.value.payment.status === 'paid')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [...(_cache[22] || (_cache[22] = [
                                                                        _createElementVNode("i", { class: "fas fa-check mr-1" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Bezahlt ", -1 /* CACHED */)
                                                                    ]))]))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createCommentVNode(" Special Requests "),
                                            (order.value.specialRequests)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                    _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 mb-4" }, "Besondere Wünsche", -1 /* CACHED */)),
                                                    _createElementVNode("div", _hoisted_53, [
                                                        _createElementVNode("p", _hoisted_54, _toDisplayString(order.value.specialRequests), 1 /* TEXT */)
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createCommentVNode(" Next Steps "),
                                            _createElementVNode("div", _hoisted_55, [
                                                _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "text-lg font-semibold text-blue-900 mb-3" }, "Was passiert als nächstes?", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_56, [
                                                    _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"flex items-start\" data-v-134c9c3e><i class=\"fas fa-check-circle text-blue-600 mr-3 mt-1\" data-v-134c9c3e></i><div data-v-134c9c3e><div class=\"font-medium\" data-v-134c9c3e>Bestellung bestätigt</div><div class=\"text-sm\" data-v-134c9c3e>Ihre Bestellung wurde erfolgreich an unser Restaurant übermittelt</div></div></div><div class=\"flex items-start\" data-v-134c9c3e><i class=\"fas fa-utensils text-blue-600 mr-3 mt-1\" data-v-134c9c3e></i><div data-v-134c9c3e><div class=\"font-medium\" data-v-134c9c3e>Zubereitung</div><div class=\"text-sm\" data-v-134c9c3e>Unsere Küche bereitet Ihre Bestellung frisch zu</div></div></div>", 2)),
                                                    _createElementVNode("div", _hoisted_57, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass([order.value.orderType === 'delivery' ? 'fas fa-motorcycle' : 'fas fa-bell', "text-blue-600 mr-3 mt-1"])
                                                        }, null, 2 /* CLASS */),
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("div", _hoisted_58, _toDisplayString(order.value.orderType === 'delivery' ? 'Lieferung' : 'Bereit zur Abholung'), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_59, _toDisplayString(order.value.orderType === 'delivery'
                                                                ? 'Ihr Essen wird zu Ihnen geliefert'
                                                                : 'Sie erhalten eine Benachrichtigung, wenn Ihre Bestellung abholbereit ist'), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Action Buttons "),
                                    _createElementVNode("div", _hoisted_60, [
                                        _createVNode(_component_router_link, {
                                            to: "/speisekarte",
                                            class: "w-full bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors duration-200 text-center block"
                                        }, {
                                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                    _createTextVNode(" Weitere Bestellung aufgeben ", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_router_link, {
                                            to: "/",
                                            class: "w-full bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold transition-colors duration-200 text-center block"
                                        }, {
                                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                    _createTextVNode(" Zur Startseite ", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        })
                                    ])
                                ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                ])
            ]));
        };
    }
});
